import BrowserUtils from '@zvuk-b2b/react-uikit/toolkit/BrowserUtils';

import {
  APPLIED_TAG_HORIZONTAL_PADDING,
  APPLIED_TAG_ICON_GAP,
  APPLIED_TAG_ICON_WIDTH,
  APPLIED_TAGS_GAP,
} from './consts';
import type { AddressTagFilterTexts, AddressTagType } from './types';

export const normalizeSearchValue = (value?: string | null) => value?.trim().toLowerCase() || '';

export const filterTagsBySearch = (tags: AddressTagType[], search: string) => {
  const normalizedSearch = normalizeSearchValue(search);

  if (!normalizedSearch) {
    return tags;
  }

  return tags.filter((tag) => normalizeSearchValue(tag.title).includes(normalizedSearch));
};

const getTextWidth = (text: string) => Math.ceil(BrowserUtils.getTextWidth(text).width);

const getAppliedTagWidth = (tag: AddressTagType) =>
  getTextWidth(tag.title) + APPLIED_TAG_HORIZONTAL_PADDING + APPLIED_TAG_ICON_WIDTH + APPLIED_TAG_ICON_GAP;

const getAppliedTagsWidth = (tags: AddressTagType[]) =>
  tags.reduce((result, tag) => result + getAppliedTagWidth(tag), 0);

export const getCollapsedSelectedTags = ({
  availableWidth,
  selectedTags,
  texts,
}: {
  availableWidth: number;
  selectedTags: AddressTagType[];
  texts: AddressTagFilterTexts;
}) => {
  if (selectedTags.length <= 1 || availableWidth <= 0) {
    return selectedTags;
  }

  const clearButtonWidth = getTextWidth(texts.clearTags);
  const allItemsCount = selectedTags.length + 1;
  const allTagsWidth =
    getAppliedTagsWidth(selectedTags) + clearButtonWidth + APPLIED_TAGS_GAP * Math.max(allItemsCount - 1, 0);

  if (allTagsWidth <= availableWidth) {
    return selectedTags;
  }

  for (let visibleCount = selectedTags.length - 1; visibleCount > 0; visibleCount -= 1) {
    const visibleTags = selectedTags.slice(0, visibleCount);
    const hiddenCount = selectedTags.length - visibleCount;
    const toggleButtonWidth = getTextWidth(texts.moreTags(hiddenCount)) + APPLIED_TAG_HORIZONTAL_PADDING;
    const renderedItemsCount = visibleTags.length + 2;
    const renderedWidth =
      getAppliedTagsWidth(visibleTags) +
      toggleButtonWidth +
      clearButtonWidth +
      APPLIED_TAGS_GAP * Math.max(renderedItemsCount - 1, 0);

    if (renderedWidth <= availableWidth) {
      return visibleTags;
    }
  }

  return selectedTags.slice(0, 1);
};
